import { buildStyles, CircularProgressbar } from 'react-circular-progressbar'
import theme from 'theme_'
import { ProgressCircleContainer } from './styles'

interface ProgressCircleProps {
  percent: number
  color?: string
  size?: number
}

function ProgressCircle({
  percent = 0,
  color = theme.colors.horizonOrange,
  size = 4,
}: ProgressCircleProps) {
  return (
    <ProgressCircleContainer size={size}>
      <CircularProgressbar
        value={percent}
        styles={buildStyles({
          strokeLinecap: 'butt',
          pathTransitionDuration: 0.5,
          pathColor: color,
          trailColor: theme.colors.activeState,
        })}
        strokeWidth={22}
      />
    </ProgressCircleContainer>
  )
}

export default ProgressCircle
